module.exports = __webpack_public_path__ + "b67d9b70b2426f3cb71bdcadc2065a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/SI1@2x.png
// module id = 820
// module chunks = 0